import { Navigate, useParams } from 'react-router-dom';
import NotFound from '@/pages/NotFound';

const LEGACY_LANGS = ['en', 'sv', 'de', 'fr', 'es', 'pt'];

export const RedirectLegacyArticle = () => {
  const { lang, slug } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  return <Navigate to={`/article/${slug}`} replace />;
};

export const RedirectLegacyCategory = () => {
  const { lang, categoryId } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  return <Navigate to={`/category/${categoryId}`} replace />;
};

export const RedirectLegacyHome = () => {
  const { lang, '*': rest } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  const target = rest ? `/${rest}` : '/';
  return <Navigate to={target} replace />;
};
